import React, { Component } from 'react'
import {Row, Col} from 'react-flexbox-grid'
import CSSModules from 'react-css-modules'
import Styles from './Footer.css'
import config from '../../config'
import {
  Link,
  LinkIcon,
  IyvBanner,
  SignupForm,
  FooterPartner,
} from '../../components'

@CSSModules(Styles)
export default class Footer extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    
    return (
      <div>
        <IyvBanner />
        <SignupForm />
        <div styleName='footer-wrap'>
          <div styleName='footer-container'>
            <div styleName='footer-inner'>
              <Row>

                <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
                  <div styleName='logo-first-wrap'>
                    <Link
                      to={config.links.ays}
                      title='As You Sow'
                      >
                      <img
                        styleName={'logo-ays'}
                        src={aysLogo}
                        alt='As You Sow'
                      />
                    </Link>
                    <div styleName='footer-donate-tagline'>
                      Empowering shareholders<br/>to change corporations for good
                    </div>
                    { /* <div styleName='footer-social-icons-item'>
                      <Link
                        to={config.links.socialAYSfb}
                        title='As You Sow Facebook'>
                        <i styleName='footer-social-icon' className='fa fa-facebook-official'/>
                      </Link>
                      <Link
                        to={config.links.socialAYStwitter}
                        title='As You Sow Twitter'>
                        <i styleName='footer-social-icon' className='fa fa-twitter'/>
                      </Link>
                      <Link
                        to={config.links.socialAYSinstagram}
                        title='As You Sow Instagram'>
                        <i styleName='footer-social-icon' className='fa fa-instagram'/>
                      </Link>
                    </div> */ }
                  </div>
                </Col>

                <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
                  <div styleName='footer-signup-headline'>
                    Support this work
                  </div>
                  <Link
                    to={config.links.donate}
                    orangebutton={true}
                    title='Donate to As You Sow'>
                    Donate<LinkIcon faclass='fa-heart'/>
                  </Link>
                  <div styleName='footer-signup-tagline'>
                    <span styleName='nowrap'>{ config.app.title }</span> is funded by contributions to <span styleName='nowrap'>As You Sow</span>, a <span styleName='nowrap'>non-profit 501(c)3</span>
                  </div>
                </Col>

                <Col styleName='footer-signup-wrap' xs={12} sm={12} md={4} lg={4}>
                  
                  <FooterPartner />

                </Col>

              </Row>

              <div styleName='footer-disclaimer-links'>
                <Link
                  to={config.routes.legal}
                  title='Legal'>
                  <span styleName='white'>Legal</span>
                </Link>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link
                  to={config.links.contact}
                  title='Contact'>
                  <span styleName='white'>Contact</span>
                </Link>
              </div>
              <div styleName='footer-copyright-text'>
                Copyright &copy; {new Date().getFullYear()} As You Sow
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}